module.exports = __webpack_public_path__ + "img/githubactions.c3b98052.webp";